import moment from "moment";
import { editAgent } from "../roles";
export const agentLocationColumns = (setter, setRow, roles) => {
  const columns = [
    {
      name: "District",
      cell: (row, index) => row["locations"][index][1]?.name,
    },
    {
      name: "Sector",
      cell: (row, index) => row["locations"][index][2]?.name,
    },
    {
      name: "Cell",
      cell: (row, index) => row["locations"][index][3]?.name,
    },
    {
      name: "Village",
      cell: (row, index) => row["locations"][index][4]?.name,
    },
    {
      name: "Start Date",
      cell: (row) => moment(row["startDatetime"]).format("DD-MM-YYYY"),
    },
    {
      name: "End Date",
      cell: (row) => moment(row["endDatetime"]).format("DD-MM-YYYY"),
    },
    {
      name: "Status",
      cell: (row) => (
        <div className='d-flex' style={{ gap: 10 }}>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: 50,
              marginTop: 6,
              backgroundColor: moment(row?.endDatetime).isAfter(moment())
                ? "green"
                : "red",
            }}
          />
          {moment(row?.endDatetime).isAfter(moment()) ? "Active" : "Suspended"}
        </div>
      ),
    },
    {
      name: roles?.some((role) => role.id === editAgent)
        ? "Suspend Agent"
        : "",
      cell: (row) =>
        roles?.some((role) => role.id === editAgent) && (
          <div
            className='d-flex justify-content-center'
            style={{ width: "100%" }}
          >
            {moment(row?.endDatetime).isAfter(moment()) && (
              <i
                className='material-icons'
                style={{ color: "red", fontSize: 23, cursor: "pointer" }}
                onClick={() => {
                  setter(true);
                  setRow(row);
                }}
                remove
                this
                location
              >
                block
              </i>
            )}
          </div>
        ),
    },
  ];
  return columns;
};
